<template>
  <b-modal
    id="modal-confirm-complete-warranty"
    ref="modal"
    size="md"
    body-class="p-0"
    content-class="border-0 shadow-sm rounded-lg"
    hide-header
    hide-footer
    @shown="onShown"
    @hidden="onHidden"
  >
    <div class="px-4 pt-4 pb-3 text-center border-bottom">
      <h5 class="mb-0 font-weight-bold text-dark">HOÀN THÀNH PHIẾU BẢO HÀNH</h5>
    </div>

    <div style="max-height: 60vh; overflow-y: auto;">

      <div class="px-4 pt-3 pb-0">
        <div class="info-row">
          <span class="info-label">Mã phiếu</span>
          <span class="info-value font-weight-bold">{{ warranty.code || `#BH-${warranty.id || ''}` }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Loại phiếu</span>
          <span class="info-value font-weight-bold text-primary">{{ warranty.warrantyServiceName || 'Bảo hành' }}</span>
        </div>

        <div class="section-divider" />

        <div class="info-row">
          <span class="info-label">Tên khách</span>
          <span class="info-value font-weight-bold">{{ warranty.customerName }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Số điện thoại</span>
          <span class="info-value">{{ warranty.customerPhone }}</span>
        </div>

        <div class="section-divider" />

        <div class="info-row">
          <span class="info-label">Tên máy</span>
          <span class="info-value font-weight-bold" style="max-width: 60%;">{{ warranty.productName }}</span>
        </div>
        <div class="info-row pb-3">
          <span class="info-label">IMEI</span>
          <span class="info-value text-monospace" style="font-size: 0.82rem;">{{ warranty.imeiCode }}</span>
        </div>
      </div>

      <div class="px-4 pb-4">
        <div
          class="rounded px-3 pt-3 pb-2"
          :class="remainingAmount > 0 ? 'payment-box-danger' : 'payment-box-success'"
        >
          <p
            class="mb-3 font-weight-bold"
            style="font-size: 0.75rem; letter-spacing: 0.08em; text-transform: uppercase;"
            :class="remainingAmount > 0 ? 'text-danger' : 'text-success'"
          >
            Thanh toán
          </p>

          <div class="d-flex justify-content-between mb-2">
            <span class="info-label">Số tiền phải thu</span>
            <span>{{ convertPrice(actualCostUnmasked) }}</span>
          </div>
          <div class="d-flex justify-content-between pb-2" style="border-bottom: 1px dashed #dee2e6;">
            <span class="info-label">Khách đã trả</span>
            <span>{{ convertPrice(paidAmount) }}</span>
          </div>

          <div class="d-flex justify-content-between align-items-center pt-2">
            <span class="font-weight-bold">Còn thiếu</span>
            <span
              class="font-weight-bold"
              style="font-size: 1.05rem;"
              :class="remainingAmount > 0 ? 'text-danger' : 'text-success'"
            >
              {{ convertPrice(remainingAmount) }}
            </span>
          </div>
        </div>
      </div>

    </div>

    <!-- FOOTER -->
    <div class="px-4 py-3 border-top d-flex" style="gap: 10px;">
      <b-button variant="outline-secondary" class="flex-grow-1" @click="closeModal">
        Huỷ
      </b-button>
      <b-button variant="primary" class="font-weight-bold" style="flex: 2;" @click="confirmComplete">
        Xác nhận hoàn thành
      </b-button>
    </div>

  </b-modal>
</template>

<script>
import { convertPrice, unMaskPrice } from '@/utils/common';
import { calculateActualCost } from '../utils/warrantyApi';
import { handleError } from '@/utils/common';

export default {
  name: 'ModalConfirmCompleteWarranty',
  props: {
    warranty: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      actualCostFromApi: null,
    };
  },
  computed: {
    actualCostUnmasked() {
      if (this.actualCostFromApi !== null) return this.actualCostFromApi;
      return unMaskPrice(this.warranty.actualCost || this.warranty.estimatedCost || 0);
    },
    paidAmount() {
      let total = 0;
      if (this.warranty.payments && this.warranty.payments.length) {
        total += this.warranty.payments.reduce((sum, p) => sum + unMaskPrice(p.paymentAmount || 0), 0);
      } else {
        const types = ['cash', 'transfer', 'credits', 'installments'];
        types.forEach(type => {
          if (this.warranty[type]) {
            total += this.warranty[type].reduce((sum, p) => sum + Number(unMaskPrice(p.paymentAmount)), 0);
          }
        });
      }
      return total;
    },
    remainingAmount() {
      return this.actualCostUnmasked - this.paidAmount;
    },
  },
  methods: {
    convertPrice,
    show() {
      this.$refs.modal.show();
    },
    closeModal() {
      this.$refs.modal.hide();
    },
    async onShown() {
      if (!this.warranty.id) return;
      try {
        const result = await calculateActualCost(this.warranty.id, {
          warrantyRepairs: this.warranty.warrantyRepairs,
          supportCost: this.warranty.supportCost,
        });
        if (result) {
          this.actualCostFromApi = unMaskPrice(result.actualCost || 0);
        }
      } catch (e) {
        handleError(e);
      }
    },
    onHidden() {
      this.actualCostFromApi = null;
    },
    confirmComplete() {
      this.$emit('confirm', this.warranty);
      this.closeModal();
    },
  },
};
</script>

<style scoped>
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 9px 0;
  border-bottom: 1px solid #f3f3f3;
}

.info-row:last-of-type {
  border-bottom: none;
}

.info-label {
  font-size: 0.85rem;
  color: #000;
  flex-shrink: 0;
  padding-right: 12px;
  font-weight: 500;
}

.info-value {
  font-size: 0.9rem;
  color: #222;
  text-align: right;
}

.section-divider {
  height: 1px;
  background: #e9ecef;
  margin: 4px 0;
}

.payment-box-danger {
  border: 1px solid #f5c6cb;
  background-color: #fff8f8;
}

.payment-box-success {
  border: 1px solid #c3e6cb;
  background-color: #f8fff8;
}
</style>